import React, { useEffect, useState } from "react";
import {
  getCategories,
  deleteCategory,
  updateCategory,
} from "../utils/firebaseCRUD";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import "./CategoryManager.css";

function CategoryManager() {
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    const data = await getCategories();
    setCategories(data);
  };

  const handleDelete = async (id) => {
    await deleteCategory(id);
    loadCategories();
  };

  const handleEdit = (cat) => {
    setEditId(cat.id);
    setName(cat.name);
  };

  const filtered = categories.filter(c => c.name.toLowerCase().includes(query.toLowerCase()));

  const handleUpdate = async (e) => {
    e.preventDefault();
    let imageUrl;
    if (image) imageUrl = await uploadToCloudinary(image);
    await updateCategory(editId, { name, ...(imageUrl && { imageUrl }) });
    setEditId(null);
    setName("");
    setImage(null);
    loadCategories();
  };

  return (
    <div className="category-manager">
      <div className="manager-header">
        <h2>Categories</h2>
        <div className="manager-actions">
          <input type="search" placeholder="Search categories" value={query} onChange={e=>setQuery(e.target.value)} />
        </div>
      </div>

      {editId && (
        <form className="edit-form" onSubmit={handleUpdate}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Category Name"
          />
          <input
            type="file"
            onChange={(e) => setImage(e.target.files[0])}
            accept="image/*"
          />
          <button type="submit">Update</button>
          <button type="button" onClick={()=>{ setEditId(null); setName(""); setImage(null); }}>Cancel</button>
        </form>
      )}

      <div className="category-list">
        {filtered.map((c) => (
          <div key={c.id} className="category-item">
            <img src={c.imageUrl} alt={c.name} />
            <h4>{c.name}</h4>
            <div className="actions">
              <button onClick={() => handleEdit(c)} className="icon-btn edit" aria-label={`Edit ${c.name}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor"/><path d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/></svg>
              </button>
              <button onClick={() => handleDelete(c.id)} className="icon-btn delete" aria-label={`Delete ${c.name}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoryManager;